var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileMenuactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C13.6406 12 15 10.6641 15 9C15 7.35938 13.6406 6 12 6C10.3359 6 9 7.35938 9 9C9 10.6641 10.3359 12 12 12ZM14.0859 12.75H13.6875C13.1719 13.0078 12.6094 13.125 12 13.125C11.3906 13.125 10.8047 13.0078 10.2891 12.75H9.89062C8.15625 12.75 6.75 14.1797 6.75 15.9141V16.875C6.75 17.5078 7.24219 18 7.875 18H16.125C16.7344 18 17.25 17.5078 17.25 16.875V15.9141C17.25 14.1797 15.8203 12.75 14.0859 12.75Z",
    fill: "#00B885"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMenuactive);
export default __webpack_public_path__ + "static/media/profile-menuactive.2c8f80b729f17d3f2bcab29ef9250898.svg";
export { ForwardRef as ReactComponent };